module.exports = __webpack_public_path__ + "static/media/multiple_hb.0caf64cb.mp4";